import React from 'react';
import { MainContent, RowCentered, SectionHeaderRowSpaceBetween } from '@ydistri/ds';
import AsoRequest from './AsoRequest/AsoRequest';
import AsoScenario from './AsoScenario/AsoScenario';
import AsoContent from './AsoContent';
import { ASO_SELECTS_ID } from './asoLib';

const Aso: React.FC = () => {
  return (
    <MainContent>
      <SectionHeaderRowSpaceBetween>
        <RowCentered $gap="2rem" id={ASO_SELECTS_ID}>
          <AsoRequest backgroundVariant="transparent-background" />
          <AsoScenario backgroundVariant="transparent-background" />
        </RowCentered>
      </SectionHeaderRowSpaceBetween>
      <AsoContent />
    </MainContent>
  );
};

export default Aso;
